var r = /* @__PURE__ */ ((i) => (i.Admin = "admin", i.Editor = "editor", i.Viewer = "viewer", i))(r || {});
export {
  r as U
};
